module.exports = __webpack_public_path__ + "static/media/4-3.689f021d.mp3";